module.exports = __webpack_public_path__ + "img/Number=72.92add4fe.png";